<div class="cart-awb w-100">
    <mat-expansion-panel [(expanded)]="panelOpenState" class="w-100">
        <mat-expansion-panel-header aria-label="Toggle panel" class="d-flex justify-content-between header">
            <div class="mat-subtitle-1 m-0 title">{{ labelAWB }}:{{ paymentRequest.awb }}</div>
        </mat-expansion-panel-header>
        <div class="info" [ngClass]="{ 'extra-item': paymentRequest.isAccessorial }">
            <div class="w-100">
                <app-payment-details-rates [payment]="paymentRequest" />
            </div>
            <div>
                <app-payment-actions-button
                    [paymentRequest]="paymentRequest"
                    (removePaymentById)="removePayment($event)"
                    (editPayment)="editPaymentRequest($event)"
                />
            </div>
        </div>
    </mat-expansion-panel>
</div>
